const mediaData = [
  {
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20frame%20with%20dramatic%20warm%20crimson%20red%20lighting%2C%20abstract%20shapes%2C%20mysterious%20elegant%20atmosphere%2C%20dark%20luxurious%20background%2C%20editorial%20video%20thumbnail%20style%2C%20soft%20glow%20accents&width=800&height=450&seq=media-img-1&orientation=landscape',
    title: '娱乐圈年度十大塌房事件完整盘点',
    duration: '15:28',
    views: '128.6万',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Editorial%20video%20frame%20with%20warm%20amber%20golden%20lighting%2C%20abstract%20geometric%20composition%2C%20mysterious%20cinematic%20atmosphere%2C%20dark%20elegant%20background%2C%20luxurious%20magazine%20thumbnail%20style&width=800&height=450&seq=media-img-2&orientation=landscape',
    title: '网红翻车名场面：那些让人笑到头掉的直播事故',
    duration: '08:42',
    views: '95.3万',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20cinematic%20scene%20with%20warm%20terracotta%20and%20bronze%20tones%2C%20abstract%20shapes%2C%20mysterious%20mood%2C%20dark%20sophisticated%20background%2C%20editorial%20film%20frame%20style%2C%20soft%20warm%20highlights&width=800&height=450&seq=media-img-3&orientation=landscape',
    title: '明星解约幕后：千万违约金到底谁来买单',
    duration: '12:05',
    views: '76.8万',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20editorial%20frame%20with%20rich%20crimson%20and%20gold%20warm%20lighting%2C%20abstract%20elegant%20composition%2C%20mysterious%20atmosphere%2C%20dark%20luxurious%20background%2C%20film%20thumbnail%20aesthetic&width=800&height=450&seq=media-img-4&orientation=landscape',
    title: '综艺魔鬼剪辑大揭秘：你看到的都是导演想让你看到的',
    duration: '10:18',
    views: '62.4万',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Artistic%20cinematic%20scene%20with%20warm%20golden%20amber%20lighting%2C%20abstract%20geometric%20shapes%2C%20mysterious%20elegant%20mood%2C%20dark%20sophisticated%20background%2C%20editorial%20video%20frame%20composition&width=800&height=450&seq=media-img-5&orientation=landscape',
    title: '从练习生到顶流：韩国娱乐圈残酷生存法则',
    duration: '18:30',
    views: '54.1万',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            热门视频
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            精选热门吃瓜视频，画面比文字更有冲击力
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {mediaData.map((item, idx) => (
            <div
              key={idx}
              className={`bg-background-100 rounded-xl overflow-hidden group cursor-pointer ${
                idx === 0 ? 'lg:col-span-2' : ''
              }`}
            >
              <div className={`relative overflow-hidden ${idx === 0 ? 'aspect-[16/7]' : 'aspect-[16/10]'}`}>
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-background-50/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-xl md:text-2xl text-primary-500 ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-black/70 text-background-50 text-xs">
                  {item.duration}
                </span>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm md:text-base font-medium text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 mb-1">
                  {item.title}
                </h3>
                <div className="flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-eye-line"></i>
                  <span>{item.views} 次观看</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}